import { createContext } from "react";
import type { ReviewApi } from "@services/reviewApi";

/** The React context holding the app's `ReviewApi`. Kept in its own module so
 * the provider component and the `useReviewApi` hook can share it without
 * tripping react-refresh's "components only" rule. */
export const ReviewApiContext = createContext<ReviewApi | null>(null);
